import React from "react";
import { cn } from "../../lib/cn";

export function Row({
  children,
  gutter,
  justify = "start",
  align,
  style,
  wrap = true,
  className,
}) {
  let gx = 0;
  let gy = 0;
  if (Array.isArray(gutter)) {
    gx = gutter[0] ?? 0;
    gy = gutter[1] ?? gutter[0] ?? 0;
  } else if (typeof gutter === "number") {
    gx = gy = gutter;
  }

  return (
    <div
      className={cn(
        "flex w-full",
        wrap ? "flex-wrap" : "flex-nowrap",
        justify === "space-between" && "justify-between",
        justify === "end" && "justify-end",
        justify === "center" && "justify-center",
        justify === "start" && "justify-start",
        align === "middle" && "items-center",
        align === "top" && "items-start",
        align === "bottom" && "items-end",
        className
      )}
      style={
        gx || gy
          ? {
              marginLeft: -gx / 2,
              marginRight: -gx / 2,
              marginTop: -gy / 2,
              marginBottom: -gy / 2,
              ...style,
            }
          : style
      }
    >
      {React.Children.map(children, (child) =>
        gx || gy
          ? React.isValidElement(child)
            ? React.cloneElement(child, {
                style: {
                  paddingLeft: gx / 2,
                  paddingRight: gx / 2,
                  paddingTop: gy / 2,
                  paddingBottom: gy / 2,
                  ...(child.props.style || {}),
                },
              })
            : child
          : child
      )}
    </div>
  );
}

export function Col({
  children,
  span = 24,
  xs,
  sm,
  md,
  lg,
  xl,
  className,
  style,
}) {
  const hasResp =
    xs !== undefined ||
    sm !== undefined ||
    md !== undefined ||
    lg !== undefined ||
    xl !== undefined;

  const pct = hasResp ? undefined : `${(Math.min(span, 24) / 24) * 100}%`;

  const resp = cn(
    xs === 24 && "w-full max-w-full",
    md === 12 && "md:w-1/2 md:max-w-[50%] md:flex-[0_0_50%]",
    md === 8 && "md:w-1/3 md:max-w-[33.333%] md:flex-[0_0_33.333%]",
    md === 6 && "md:w-1/4 md:max-w-[25%] md:flex-[0_0_25%]",
    md === 18 && "md:w-3/4 md:max-w-[75%] md:flex-[0_0_75%]",
    lg === 8 && "lg:w-1/3 lg:max-w-[33.333%] lg:flex-[0_0_33.333%]"
  );

  return (
    <div
      className={cn("min-w-0", resp, className)}
      style={{
        ...(pct
          ? { flexBasis: pct, width: pct, maxWidth: pct }
          : hasResp
            ? { flex: "1 1 auto", width: "100%", maxWidth: "100%" }
            : {}),
        ...style,
      }}
    >
      {children}
    </div>
  );
}
